module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "fst9dshz",
    dataset: process.env.GATSBY_SANITY_DATASET || "production"
  }
};
